import React from "react";
import HappySchoolDataTable from "./HappySchoolDataTable";

// Bảng "Chấm công phòng Đào tạo" — tính công theo NGÀY (không theo tiết như
// GV Văn hoá), nhập từ file Excel "Chấm công phòng Đào tạo tháng 08.2026".
// Chức năng riêng, ngang hàng với "Chấm công tháng — GV Văn hoá".
const CHAMCONG_DAOTAO_TABLE_KEY = "chamCongDaoTaoThang8";
const CHAMCONG_DAOTAO_CFG = {
  title: "Chấm công phòng Đào tạo — Tháng 8/2026",
  columns: [
    { key: "stt", label: "STT", width: 50 },
    { key: "hoten", label: "Họ và tên", width: 180 },
    { key: "phongban", label: "Phòng ban", width: 110 },
    { key: "tuan1", label: "Tuần 01-02/08 (công)", width: 130 },
    { key: "tuan2", label: "Tuần 03-09/08 (công)", width: 130 },
    { key: "tuan3", label: "Tuần 10-16/08 (công)", width: 130 },
    { key: "tuan4", label: "Tuần 17-23/08 (công)", width: 130 },
    { key: "tuan5", label: "Tuần 24-30/08 (công)", width: 130 },
    { key: "tuan6", label: "Ngày 31/08 (công)", width: 120 },
    { key: "tongcong", label: "Tổng công", width: 100 },
    { key: "ghichu", label: "Ghi chú", width: 120 },
  ],
  totalColumns: ["tuan1", "tuan2", "tuan3", "tuan4", "tuan5", "tuan6", "tongcong"],
  publishable: true,
};

const HappySchoolChamCongDaoTao = () => (
  <HappySchoolDataTable tableKey={CHAMCONG_DAOTAO_TABLE_KEY} config={CHAMCONG_DAOTAO_CFG} />
);

export default HappySchoolChamCongDaoTao;
